export const createListApiKeysRequest = () => ({
  url: "/api_keys",
  method: "GET",
});

export const createCreateApiKeyRequest = (name) => ({
  url: "/api_keys",
  method: "POST",
  data: {
    api_key: { name },
  },
});

export const createDeleteApiKeyRequest = () => ({
  url: "/api_keys",
  method: "DELETE",
});
